import axios from "axios";

const origin = () => {
  const url = new URL(process.env.REACT_APP_ANALYTICS_API_URL);
  if (url.protocol !== "https:" || url.username || url.password || url.search || url.hash || url.pathname !== "/") {
    throw new Error("Demo session API is unavailable.");
  }
  return url.origin;
};
const request = async (path, config) => {
  try { return (await axios({ url: `${origin()}${path}`, ...config })).data; }
  catch (error) {
    // Never pass Axios request headers (the report credential) to the UI or logs.
    throw Object.assign(new Error("Unable to load the demo session."), {
      status: error?.response?.status,
      code: error?.response?.data?.error?.code,
    });
  }
};

export const redeemDemoCode = async (code, turnstileToken, signal) => {
  if (!/^\d{4}$/.test(code)) throw Object.assign(new Error("Enter four digits."), { status: 400 });
  const grant = await request("/public/demo-codes/redeem", { method: "POST", data: { code, turnstileToken }, signal });
  if (!/^[A-Za-z0-9_-]{43}$/.test(grant?.token) || !Number.isFinite(Date.parse(grant?.expiresAt))) throw new Error("Invalid demo access response.");
  return grant;
};

export const readDemoSession = async (grant, signal) => {
  const events = [], cursors = new Set();
  let nextToken;
  for (let page = 0; page < 200; page++) {
    if (Date.parse(grant.expiresAt) <= Date.now()) throw Object.assign(new Error("Demo access expired."), { status: 410 });
    const query = new URLSearchParams({ limit: "500" });
    if (nextToken) query.set("nextToken", nextToken);
    const report = await request(`/public/shares?${query}`, { method: "GET", headers: { Authorization: `Bearer ${grant.token}` }, signal });
    if (!Array.isArray(report?.events) || report.expiresAt !== grant.expiresAt ||
        !(report.nextToken == null || typeof report.nextToken === "string")) throw new Error("Invalid demo report response.");
    events.push(...report.events);
    if (!report.nextToken) {
      if (Date.parse(grant.expiresAt) <= Date.now()) throw Object.assign(new Error("Demo access expired."), { status: 410 });
      return { ...report, events };
    }
    if (cursors.has(report.nextToken)) throw new Error("Invalid demo report pagination.");
    cursors.add(report.nextToken); nextToken = report.nextToken;
  }
  throw new Error("This demo report is too large to display.");
};

// The existing report uses pk/sk as presentation fields. These are local display
// values only, never backend identifiers or authorization inputs.
export const demoTimelineEvents = events => events.map(event => ({
  ...event, pk: event.eventType || event.label, sk: event.timestamp,
}));
